export default function PHP_inet_pton() {
  return (
    <div>
      <h1>PHP_inet_pton</h1>
    </div>
  );
}
